/* eslint-disable no-nested-ternary */
import { Box, Typography } from '@mui/material';
import { GalleryIcon } from 'assets/icons';
import { VideoPlayer } from 'components/molecules';
import compressFile from 'assets/images/compress-file.png';
import { FileType, getDocumentIcon } from 'utils/file-uploader';
import { isYouTubeUrl } from 'utils/youtube-utils';
import { isVimeoUrl } from 'utils/vimeo-utils';
import YouTubePreview from '../youtube-preview';
import VimeoPreview from '../vimeo-preview';

interface ContentMediaViewProps {
  mediaType: string;
  fileName?: string | undefined;
  thumbnail?: string;
  url?: string;
  backgroundSize?: string;
  fileType?: string;
}

const ContentMediaView = ({
  mediaType, fileName, url, thumbnail, backgroundSize = '80%', fileType,
}: ContentMediaViewProps) => (
  <div style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
    {url === ''
      ? (

        <Box
          sx={{
            backgroundColor: '#F2F2F2',
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '5px',
          }}
        >
          <GalleryIcon fontSize="large" />
        </Box>

      )

      : (
        mediaType === FileType.IMAGE ? (
          <Box
            sx={{
              backgroundImage: `url(${url})`,
              backgroundColor: '#F2F2F2',
              backgroundSize,
              backgroundPosition: 'center',
              height: '100%',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              backgroundRepeat: 'no-repeat',
              alignItems: 'center',
              borderRadius: '5px',
            }}
          />
        )
          : mediaType === FileType.VIDEO ? (
            (() => {
              if (url && isYouTubeUrl(url)) {
                return (
                  <YouTubePreview
                    url={url}
                    height="auto"
                    width="100%"
                    showControls
                    style={{
                      borderRadius: '5px',
                      overflow: 'hidden',
                    }}
                  />
                );
              }

              if (url && isVimeoUrl(url)) {
                return (
                  <VimeoPreview
                    url={url}
                    height="auto"
                    width="100%"
                    showControls
                    style={{
                      borderRadius: '5px',
                      overflow: 'hidden',
                    }}
                  />
                );
              }

              return <VideoPlayer url={url} thumbnail={thumbnail} />;
            })()
          ) : mediaType === FileType.DOCUMENT ? (
            <Box
              sx={{
                backgroundColor: '#F2F2F2',
                height: '100%',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                borderRadius: '5px',
              }}
            >
              <Box
                component="img"
                sx={{
                  width: '80px',
                  height: 'auto',
                  objectFit: 'contain',
                  margin: '20px',
                }}
                src={getDocumentIcon(fileType || '')}
                alt="Document"
              />
              {fileName && fileName.length > 0 && (
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2, textAlign: 'center' }}>
                  {fileName}
                </Typography>
              )}
            </Box>
          ) : (
            mediaType === FileType.COMPRESSED_FILE ? (
              <Box
                sx={{
                  backgroundColor: '#F2F2F2',
                  height: '100%',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <Box
                  component="img"
                  sx={{
                    width: '65px',
                    height: 'auto',
                    objectFit: 'cover',
                    margin: '20px',
                  }}
                  src={compressFile}

                />
                { fileName && fileName.length > 0 && (
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2, textAlign: 'center' }}>
                  {fileName}
                </Typography>
                )}
              </Box>
            ) : (
              <Box
                sx={{
                  backgroundColor: '#F2F2F2',
                  height: '100%',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '5px',
                }}
              >
                <GalleryIcon fontSize="large" />
              </Box>
            )
          ))}
  </div>

);

ContentMediaView.defaultProps = {
  fileName: '',
  url: '',
  thumbnail: '',
  backgroundSize: '80%',
  fileType: '',
};

export default ContentMediaView;
